// extracted by css-extract-rspack-plugin
export default {"iconContainer":"aPDKahYl","text":"liysKAuP","textVisible":"PVBV1Fdj"};